import React, {useEffect, useState, useContext} from "react";
import {HeadDropDown, LeftHead, RightHead, BodyDropDown} from "../../../../styles/ContentViews";
import {ButtonWithIcon, AppButton} from "../../../../styles/Butttons";
import {ReactComponent as SeeIcon} from "../../../../assets/icons/eye.svg";
import {ReactComponent as EditIcon} from "../../../../assets/icons/edit.svg";
import {ReactComponent as PlusIcon} from "../../../../assets/icons/plus.svg";
import Accordion from "../../../../components/accordion/Accordion";
import {orderDataByIndex} from "../../../../hooks/helpers";
import ElementoItem from "./Components";
import styled from "styled-components";
import SuccesModal from "../../../../components/modals/SuccessModal";
import {Col, Grid} from "../../../../styles/Grid";
import {ReactComponent as ToggleIcon} from "../../../../assets/icons/double_arrow.svg";
import {HomeContext} from "../../../../context/HomeProvider";
import {PageWebUrl} from "../../../../services/ApiUrl";

export default function ElementosHome({theme, status, changeMode}) {
   const [editable, setEditable] = useState(false);
   const [isLoading, setIsLoading] = useState({data: true});
   const [showSuccess, setShowSuccess] = useState(false);
   // const [data, setData] = useState([]);
   const {blocksHome, currentBlocks, getBlocks, addBlockClean, saveNewDats} = useContext(HomeContext);

   useEffect(() => {
      getBlocks();
   }, []);

   const addOne = () => {
      // let neew = [...data, {idReference: 1, type: "Facilitators"}];
      // setData(neew);
   };

   return (
      <>
         <Accordion theme={theme} title="seleccion de elementos para home" status={status} changeMode={(val) => changeMode(val, 0)}>
            <>
               <HeadDropDown>
                  <LeftHead>
                     <ButtonWithIcon
                        Icon={SeeIcon}
                        text="Vista previa"
                        action={() => {
                           window.open(PageWebUrl + "#blocks", "_blank");
                        }}
                     />
                  </LeftHead>
                  <RightHead>
                     {!editable && (
                        <ButtonWithIcon
                           right={true}
                           Icon={EditIcon}
                           action={() => {
                              setEditable(!editable);
                           }}
                           text=""
                        />
                     )}
                     {editable && <ButtonWithIcon right={true} Icon={PlusIcon} action={addBlockClean} text="" />}
                  </RightHead>
               </HeadDropDown>
               <BodyDropDown>
                  <ElementosContainer>
                     {editable
                        ? React.Children.toArray(
                             currentBlocks.map((item) => {
                                //   if (!item.data[0]) return null;
                                return <ElementoItem data={item} editable={editable} classname="element" />;
                             }),
                          )
                        : React.Children.toArray(
                             blocksHome.map((item) => {
                                if (!item.data[0]) return null;
                                return <ElementoItem data={item} editable={editable} classname="element" />;
                             }),
                          )}
                  </ElementosContainer>
                  {editable && (
                     <HeadDropDown>
                        <RightHead>
                           <AppButton
                              onClick={() => {
                                 saveNewDats();
                                 /* setEditable(false);
                                 setShowSuccess(true); */
                              }}
                           >
                              Guardar
                           </AppButton>
                        </RightHead>
                     </HeadDropDown>
                  )}
               </BodyDropDown>
            </>
         </Accordion>
         <SuccesModal theme={theme} isOpen={showSuccess} close={() => setShowSuccess(false)} />
      </>
   );
}

const ElementosContainer = styled.div`
   display: flex;
   justify-content: space-between;
   flex-wrap: wrap;
   width: 80%;

   .headElements {
      display: flex;
      justify-content: space-between;
      cursor: pointer;

      & p {
         margin: 0;
      }
   }
   > div {
      padding: 1em;
      box-sizing: border-box;
      margin-bottom: 0.5em;
      p {
         user-select: none;
      }

      &:nth-child(odd) {
         background: #e9ecf5;
      }
   }

   .elementBlock {
      width: 50%;
      // background: red;
   }
`;

const dataItems = [
   {idReference: 1, type: "Facilitators"},
   {idReference: 2, type: "Courses"},
];
